// extracted by mini-css-extract-plugin
module.exports = {"header-message":"header-message-db2c64427d4817de2c1e7260a845d42d","list-header-banner":"list-header-banner-b1a874df10d8418e18bf07e91822f0eb"};